import { useState, useEffect } from 'react';

interface NavigationProps {
  onOpenReservation: () => void;
}

export default function Navigation({ onOpenReservation }: NavigationProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}>
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <a href="#inicio" className="flex items-center space-x-2 cursor-pointer">
              <div className="h-12 flex items-center">
                <img 
                  src="https://static.readdy.ai/image/1122cb27b252d075a2451a67773799cc/7670fadaa3ac02a0b489708526bd4cce.jpeg"
                  alt="WeBus Transporte Málaga"
                  className={`h-10 w-auto object-contain transition-all duration-300 ${
                    isScrolled ? 'brightness-100' : 'brightness-0 invert'
                  }`}
                />
              </div>
            </a>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-8">
              <a 
                href="#inicio" 
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}
              >
                Inicio
              </a>
              <a 
                href="#servicios" 
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}
              >
                Servicios
              </a>
              <a 
                href="#flota" 
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}
              >
                Flota
              </a>
              <a 
                href="#precios" 
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}
              >
                Precios
              </a>
              <a 
                href="#contacto" 
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}
              >
                Contacto
              </a>
            </div>

            {/* CTA Button */}
            <div className="hidden lg:flex items-center space-x-4">
              <button 
                onClick={onOpenReservation}
                className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Reservar Ahora
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden p-2 cursor-pointer ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="lg:hidden bg-white border-t border-gray-200 py-4">
              <div className="flex flex-col space-y-4">
                <a 
                  href="#inicio" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-gray-700 hover:text-teal-600 font-medium px-4 py-2 cursor-pointer"
                >
                  Inicio
                </a>
                <a 
                  href="#servicios" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-gray-700 hover:text-teal-600 font-medium px-4 py-2 cursor-pointer"
                >
                  Servicios
                </a>
                <a 
                  href="#flota" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-gray-700 hover:text-teal-600 font-medium px-4 py-2 cursor-pointer"
                >
                  Flota
                </a>
                <a 
                  href="#precios" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-gray-700 hover:text-teal-600 font-medium px-4 py-2 cursor-pointer"
                >
                  Precios
                </a>
                <a 
                  href="#contacto" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-gray-700 hover:text-teal-600 font-medium px-4 py-2 cursor-pointer"
                >
                  Contacto
                </a>
                <button 
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    onOpenReservation();
                  }}
                  className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-full font-medium mx-4 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Reservar Ahora
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>
    </>
  );
}